import { render, staticRenderFns } from "./adduser.vue?vue&type=template&id=71bf5d74&scoped=true"
import script from "./adduser.js?vue&type=script&lang=js&external"
export * from "./adduser.js?vue&type=script&lang=js&external"
import style0 from "./adduser.vue?vue&type=style&index=0&id=71bf5d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf5d74",
  null
  
)

export default component.exports